export const USB_OUTPUT_FULL_MIX = 'USB_OUTPUT_FULL_MIX'
export const USB_OUTPUT_REMOTE_ONLY = 'USB_OUTPUT_REMOTE_ONLY'
export const USB_OUTPUT_LOCAL_ONLY = 'USB_OUTPUT_LOCAL_ONLY'
export const USB_OUTPUT_DISABLED = 'USB_OUTPUT_DISABLED'
